import React from 'react'
import OrderHeader from './OrderHeader'
import BuyerInfoForm from './BuyerInfoForm'
import OrderProductList from './OrderProductList'
import OrdersProgressBar from './OrdersProgressBar'

const SingleOrder = ({ order }) => {
  return (
    <div className="bg-white rounded-2xl shadow-md mb-6 border border-slate-200 overflow-hidden">
      <OrderHeader order={order} />
      <div className="p-4 sm:p-6 lg:p-7">
        <BuyerInfoForm order={order} />
        <OrderProductList products={order.products} />

        <h3 className="text-base lg:text-[17px] font-semibold mb-6 md:mb-2 text-slate-800 flex items-center gap-2">
          <i className="fas fa-truck text-citrus-red"></i>
          შეკვეთის სტატუსი
        </h3>

        <OrdersProgressBar
          statuses={order.info.statuses}
          currentStatusKey={order.info.status}
        />
      </div>
    </div>
  )
}

export default SingleOrder
